import { Box, Button, Grid, Typography } from "@mui/material";
import { Tag } from "../../model/Tag";
import React from "react";
import { Formik, FormikProps } from "formik";
import TagEditorLine from "./TagEditorLine";
import useAxios from "../../hooks/useAxios";
import { baseUrl } from "../../constants";
import _isEmpty from "lodash/isEmpty";

interface TagEditorProps {
  availableRoles: Array<Tag>;
  fetchRoles: () => void;
}

const TagEditor = ({ availableRoles, fetchRoles }: TagEditorProps) => {
  const [axiosInstance] = useAxios();
  const handleSubmit = async (values: any) => {
    // Handle form submission logic here
    console.log(
      "Form submitted with values:",
      values.tags.filter((x: Tag) => !_isEmpty(x))
    );
    await axiosInstance.post(`${baseUrl}/tags`, {
      tags: values.tags.filter((x: Tag) => !_isEmpty(x)),
    });
    await fetchRoles();
  };

  const handleDelete = async (index: number) => {
    await axiosInstance.delete(`${baseUrl}/tags/${availableRoles[index].id}`);
    await fetchRoles();
  };

  return (
    <Box>
      <Box id="header" sx={{ marginLeft: "3rem", marginTop: "2.5rem" }}>
        <Grid container spacing={1}>
          <Grid size={12}>
            <Typography variant="h5" sx={{ marginBottom: "3rem" }}>
              Gestion des rôles
            </Typography>
          </Grid>
          <Formik
            initialValues={{
              tags: [...availableRoles, {}],
            }}
            enableReinitialize
            onSubmit={handleSubmit}
          >
            {({ values, submitForm }: FormikProps<{ tags: Tag[] }>) => (
              <Grid container spacing={1}>
                {values.tags.map((tag: Tag, index: number) => (
                  <React.Fragment key={tag.id || `new-${index}`}>
                    <TagEditorLine
                      tag={tag}
                      index={index}
                      fieldNamePrefix={`tags[${index}]`}
                      isLast={index === values.tags.length - 1}
                      handleDelete={handleDelete}
                    />
                  </React.Fragment>
                ))}
                <Grid size={12}>
                  <Button sx={{ marginTop: "3rem" }} onClick={submitForm}>
                    Sauvegarder
                  </Button>
                </Grid>
              </Grid>
            )}
          </Formik>
        </Grid>
      </Box>
    </Box>
  );
};
export default TagEditor;
